import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";

const UpdatePrivateRateList = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setselectedRowsData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [productName, setProductName] = useState("");
  const [storeProduct, setStoreProduct] = useState([]);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  function resetFields() {
    setselectedRowsData({
      product_name: "",
      party_name: "",
      private_rate: "",
    });
  }
  const handleUpdateDataSubmit = async (e) => {
    e.preventDefault();
    const { id, party_name, product_name, private_rate } = selectedRowsData;

    let BASE_URL =
      SERVER_URL + `/api/private-rate/private-rate-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        party_name,
        product_name,
        private_rate,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };
  const getProductData = async () => {
    let BASE_URL = SERVER_URL + `/api/product/all-products-distinct/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreProduct(result.data);
    } else {
      setStoreProduct([]);
    }
  };
  useEffect(() => {
    getProductData();
  }, [productName]);
  return (
    <div
      className="modal custom-modal fade"
      id="updateModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Update Private Rate
            </h5>
            <button
              type="button"
              className="custon-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={resetFields}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Add Party Name</h4> */}
                  <form
                    className="form-sample"
                    onSubmit={handleUpdateDataSubmit}
                  >
                    {/* <p className="card-description">Personal info</p> */}
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="discom_name">Party Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="party_name"
                            id="party_name"
                            placeholder="Enter Party Name"
                            value={selectedRowsData?.party_name}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="Pole">Size</label>
                          <select
                            type="text"
                            className="form-control form-control-lg"
                            name="product_name"
                            id="Pole"
                            onChange={updateHandleChange}
                            value={selectedRowsData?.product_name}
                            required
                          >
                            <option value="">Select Size</option>
                            {storeProduct &&
                              storeProduct?.length > 0 &&
                              storeProduct?.map((item, id) => {
                                return (
                                  <option
                                    value={item.size}
                                    key={id}
                                  >{`${item.size}`}</option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="private_rate">Private Rate</label>
                          <input
                            type="number"
                            className="form-control"
                            name="private_rate"
                            id="private_rate"
                            placeholder="Enter private Rate"
                            value={selectedRowsData?.private_rate}
                            onChange={updateHandleChange}
                            required
                            autoComplete="off"
                            min="0"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary mr-2 mt-3"
                      type="submit"
                      // onClick={handleUpdateDataSubmit}
                    >
                      Save
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePrivateRateList;
